import { graphql, useFragment } from 'react-relay';

import { TaskDifferenceItemList_difference$key } from '../../../relay/__generated__/TaskDifferenceItemList_difference.graphql';
import { isNullable } from '../../../utils/is';
import EmptyState from '../../core/EmptyState';
import EnumPair from '../../core/EnumPair';
import ItemList from '../../core/ItemList';
import Text from '../../core/Text';
import View from '../../core/View';
import DiffItem from '../../difference/DiffItem';

const TaskDifferenceItemList_difference = graphql`
  fragment TaskDifferenceItemList_difference on Difference {
    ... on TaskDifference {
      title {
        ...DiffItem_diff
      }
      description {
        ...DiffItem_diff
      }
      status {
        ...DiffItem_diff
      }
      originalTask {
        ...DiffItem_diff
      }
      creationType {
        ...DiffItem_diff
      }
      assignedTo {
        ...DiffItem_diff
      }
    }
  }
`;

type Props = { difference: TaskDifferenceItemList_difference$key };

const TaskDifferenceItemList = ({ difference }: Props) => {
  const { title, description, status, originalTask, creationType, assignedTo } = useFragment(
    TaskDifferenceItemList_difference,
    difference,
  );

  const diffItems = [
    { title: '원본 문항', diff: originalTask },
    {
      title: '변형 정도',
      diff: creationType,
      renderItem: (beforeOrAfter: string) => (
        <EnumPair typename={'TaskProblemCreationTypeEnum'}>{beforeOrAfter}</EnumPair>
      ),
    },
    { title: '제목', diff: title },
    { title: '설명', diff: description },
    {
      title: '상태',
      diff: status,
      renderItem: (beforeOrAfter: string) => <EnumPair typename={'TaskStatusEnum'}>{beforeOrAfter}</EnumPair>,
    },
    { title: '작업자', diff: assignedTo },
  ].filter(({ diff }) => !isNullable(diff));
  return (
    <ItemList
      items={diffItems}
      renderItem={({ title: itemTitle, diff, renderItem }) => (
        <>
          <Text sx={{ fontSize: 1, fontWeight: 'bold' }}>{itemTitle}</Text>
          <View sx={{ marginTop: 2 }}>
            <DiffItem diff={diff!} renderItem={renderItem} />
          </View>
        </>
      )}
      renderItemWrapper={(children, { title: itemTitle }, i) => (
        <View key={itemTitle} sx={{ marginTop: i > 0 ? 3 : 0 }}>
          {children}
        </View>
      )}
      emptyState={
        <View sx={{ paddingY: 6 }}>
          <EmptyState
            title={'기록되지 않은 히스토리이에요'}
            description={'이 기능이 만들어지기 전에 일어난 일이거나 오류로 누락된 히스토리입니다.'}
          />
        </View>
      }
    />
  );
};

export default TaskDifferenceItemList;
